import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-style-one',
  templateUrl: './courses-style-one.component.html',
  styleUrls: ['./courses-style-one.component.scss']
})
export class CoursesStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
